import React from 'react';
import axios from 'axios';
import Swal from 'sweetalert2'
import { useNavigate } from 'react-router-dom';
import '../Estilos/EstiloSap.css';
import 'bootstrap/dist/css/bootstrap.css';
import '../New Template/Botones.css';
import '../New Template/Formularios1.css';
import Datos from './Datos';
import Hacienda from './Hacienda';
import ConsecutivosContenedor from './ConsecutivosContenedor';
import Usuarios from './Usuarios';
import loading from '../New Template/images/loading.gif';
import '../Companias/BotonesPestanas.css';
import { useAuth } from '../contextos/AuthProvider'
import { EncApi, EncabezadoPost } from '../Comunes/Listas';

const DetalleCia = (props) => {

    const navigate = useNavigate();
    const { Token } = useAuth();
    const Salir = () => {
        navigate("/Companias/GeneralCia");
    }
    const handleOnSubmit = (e) => {
        console.log("in submit");
        if (e.which === '13') {
            e.preventDefault();
        }
        e.preventDefault();
    };

    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (file instanceof Blob) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result.replace("data:", "").replace(/^.+,/, "");
                setGestor({ ...Gestor, "LlaveBase64": base64String, "RutaLlave": file.name });
                console.log(base64String);
            };
            reader.readAsDataURL(file);
        } else {
            console.error("The selected file is not a valid Blob.");
        }
    }


    const AccionProvincia = (codigo) => {
        axios.get(`https://smartfecr.com:2020/SmartContrackBack/api/Companias/CantonesDeProvincia?Id=${codigo}`, EncApi(Token))
            .then(res => {
                const { data } = res;
                console.log(data);
                setLosCantones(data.CantonesVecinos);
                setLosDistritos(data.DistritosVecinos);

            });
        setGestor({ ...Gestor, "Provincia": codigo, "Canton": "1", "Distrito": "1" });
    }

    //GESTOR DE LA COMPAÑIA
    const [Gestor, setGestor] = React.useState({
        IdCia: 0,
        BDCompania: '',
        NombreCliente: '',
        Cedula: '',
        Codigo: '',
        NotaNC: 'D',
        SNcontado: '0',
        Ambiente: 'T',
        TipoCedula: '02',
        NotaExtraDetalle: 'CRC'
    });
    const CambiaDatosGestor = (e) => {
        const { className, name, value, type } = e.target;
        if (className === 'ck') {

            e.target.checked = false;
        }
        switch (name) {
            case 'Provincia':
                AccionProvincia(value);
                break;
            case 'Canton':

                axios.get(`https://smartfecr.com:2020/SmartContrackBack/api/Companias/DistritosDeCanton?IdProvincia=${Gestor.Provincia}&idCanton=${value}`, EncApi(Token))
                    .then(res => {
                        const { data } = res;

                        setLosDistritos(data);
                        setGestor({ ...Gestor, "Canton": (type === 'number') ? parseInt(value) : value, "Distrito": "1" });

                    });

                break;
            default:
                setGestor({ ...Gestor, [name]: (type === 'number') ? parseInt(value) : value });
        }

    }

    function ValidarDatos() {
        let Mensaje = '';
        if (!InfoLicencia[0]) {
            Mensaje = 'Falta información de Datos Compañia';
        }
        if (LosUsuarios.length === 0) {
            Mensaje = 'Falta información de Usuarios';
        }
        if (LosConsecutivos.length === 0) {
            Mensaje = 'Falta información de Consecutivos';
        }
        if (LasActividades.length === 0) {
            Mensaje = 'Falta información de Actividades';
        }
        if (Gestor.SNcontado || Gestor.SNcontado === '') {
            Mensaje = 'Falta información de Descuento';
        }
        if (Gestor.NotaND || Gestor.NotaND === '') {
            Mensaje = 'Falta información de Nota de Monto Mensual';
        }
        return Mensaje;
    }

    const Guardar = () => {
        let Mensaje = ValidarDatos();
        if (Mensaje !== '') {
            Swal.fire({
                title: '¿Seguro en guardar los datos de Compañia?',
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonText: 'Si, de acuerdo',
                denyButtonText: `No, Cancelar`,
            }).then(async (result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    Swal.fire({
                        title: "Enviando...",
                        text: "Favor esperar mientras se guarda la información",
                        position: 'top-center',
                        imageUrl: loading,
                        backdrop: true,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    });
                    let compania = {
                        Gestor: Gestor,
                        LlaveBase64: Gestor.LlaveBase64,
                        InfoLicencia: InfoLicencia[0],
                        MisUsuarios: LosUsuarios,
                        MisConsecutivos: LosConsecutivos,
                        MisActividades: LasActividades
                    }
                    console.log(JSON.stringify(compania));
                    await fetch(`https://smartfecr.com:2020/SmartContrackBack/api/Companias/GuardaCompania`, EncabezadoPost(Token, compania))
                        .then(async res => {
                            if (res.status === 200) {
                                const data = await res.json(); // <-- AQUÍ conviertes la respuesta a JSON
                                if (data[0].Codigo > 0) {
                                    Swal.fire({
                                        position: 'top-center',
                                        icon: 'success',
                                        title: 'Compañia Guardada Exitosamente',
                                        showConfirmButton: false,
                                        timer: 1200
                                    })
                                    navigate("/Companias/GeneralCia");
                                } else {
                                    Swal.fire({
                                        icon: 'error',
                                        title: 'Error al guardar',
                                        text: data[0].Mensaje,
                                    })
                                }
                            } else {
                                console.error("Error: ", res.status);
                            }
                        })
                        .catch(error => {
                            console.error("Error: ", error);
                        });


                }
            })
        }
        else {
            Swal.fire({
                icon: 'error',
                title: 'Error al guardar',
                text: Mensaje,
            })
        }
    }



    const [ModoActual, setModoActual] = React.useState('D');

    //****** CONSECUTIVOS ******/
    const [LosConsecutivos, setConsecutivos] = React.useState([]);
    const ActualizarConsecutivo = index => e => {
        const { name, value, type } = e.target;
        console.log(index);
        let Lista = LosConsecutivos.map((item, i) => i === index ? { ...item, [name]: (type === 'number') ? parseInt(value) : value } : item)
        setConsecutivos(Lista);
    };
    const EliminarConsecutivo = (index) => {
        const newConsecutivos = [...LosConsecutivos];
        newConsecutivos.splice(index, 1);
        setConsecutivos(newConsecutivos);
    };
    const AgregarConsecutivo = (nuevoConsecutivo) => {
        setConsecutivos([...LosConsecutivos, nuevoConsecutivo]);
    };

    //****** USUARIOS ******/
    const [LosUsuarios, setUsuarios] = React.useState([]);
    const AgregarUsuario = (nuevoUsuario) => {
        setUsuarios([...LosUsuarios, nuevoUsuario]);
    };
    const ActualizarUsuario = index => e => {
        const { name, value, type } = e.target;
        let Lista = LosUsuarios.map((item, i) => i === index ? { ...item, [name]: (type === 'number') ? parseInt(value) : value } : item)
        setUsuarios(Lista);
    };

    const ResetearClave = (index) => {

        axios.get(`https://smartfecr.com:2020/SmartContrackBack/api/Companias/CambiarClave?CodigoUsuario=${LosUsuarios[index].CODIGO}&Clave=${LosUsuarios[index].CLAVE}`, EncApi(Token))
            .then(res => {
                if (res.status === 200) {
                    const { data } = res;
                    console.log(data);
                    if (data.Codigo === 0) {
                        Swal.fire({
                            position: 'top-center',
                            icon: 'success',
                            title: 'Clave reseteada Exitosamente',
                            showConfirmButton: false,
                            timer: 1200
                        })

                    }
                    else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error al guardar',
                            text: data.Mensaje,
                        })
                    }
                } else {
                    console.error("Error: ", res.status);
                }
            })
            .catch(error => {
                console.error("Error: ", error);
            });
    }

    const EliminarUsuario = (index) => {
        const newUsuarios = [...LosUsuarios];
        newUsuarios.splice(index, 1);
        setUsuarios(newUsuarios);
    };

    //****** ACTIVIDADES ******/
    const [LasActividades, setActividades] = React.useState([]);
    const EliminarActividad = (index) => {
        const newActividades = [...LasActividades];
        newActividades.splice(index, 1);
        setActividades(newActividades);
    };


    const AgregarActividad = (nuevaActividad) => {
        console.log(nuevaActividad);
        setActividades([...LasActividades, nuevaActividad]);
    };

    //****** Cantones & Distritos ******/
    const [LosCantones, setLosCantones] = React.useState([]);
    const [LosDistritos, setLosDistritos] = React.useState([]);

    //****** INFO LICENCIA ******/
    const [InfoLicencia, setInfoLicencia] = React.useState([]);
    const CambiaInfoLicencia = (e) => {
        const { name, value, type } = e.target;
        setInfoLicencia(prevInfoLicencia => {
            const updatedInfoLicencia = [...prevInfoLicencia];
            updatedInfoLicencia[0] = { ...updatedInfoLicencia[0], [name]: (type === 'number') ? parseInt(value) : value };
            return updatedInfoLicencia;
        });
    }
    const SubirLogo = (e) => {
        console.log('Subiendo logo...');
        const file = e.target.files[0];
        if (file instanceof Blob) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result.replace("data:", "").replace(/^.+,/, "");
                setInfoLicencia(prevInfoLicencia => {
                    const updatedInfoLicencia = [...prevInfoLicencia];
                    updatedInfoLicencia[0] = { ...updatedInfoLicencia[0], "LOGO": base64String };
                    return updatedInfoLicencia;
                });

            };
            reader.readAsDataURL(file);
        } else {
            console.error("The selected file is not a valid Blob.");
        }
    }

    React.useEffect(() => {

        //console.log(props.EntidadActual);
        //console.log(props.EntidadActual);
        if (props.EntidadActual > 0) {
            axios.get(`https://smartfecr.com:2020/SmartContrackBack/api/Companias/ObtenerCompaniaPorId?Id=${props.EntidadActual}`, EncApi(Token))
                .then(res => {
                    const { data } = res;
                    //console.log(data);
                    setLosCantones(data.CantonesVecinos);
                    setLosDistritos(data.DistritosVecinos);
                    setGestor(data.Compania);
                    setConsecutivos(data.Consecutivos);
                    setUsuarios(data.Usuarios);
                    setActividades(data.Actividades);
                    setInfoLicencia(data.InfoLicencia);
                });
        }
        else {
            console.log("nueva compañia");
            AccionProvincia('1');
            setConsecutivos([]);
            setUsuarios([]);
            setActividades([]);
            setInfoLicencia(prevInfoLicencia => {
                const updatedInfoLicencia = [...prevInfoLicencia];
                updatedInfoLicencia[0] = { ...updatedInfoLicencia[0], "LOGO": null, "ESTADO": '1', "FECHA": new Date().toISOString().split('T')[0], "CLIENTE": '0' };
                return updatedInfoLicencia;
            });
        }



        // eslint-disable-next-line
    }, []);
    if (Gestor && InfoLicencia[0]) {
        return <div className='main-block'>
            <div className="form" onSubmit={(e) => handleOnSubmit(e)}>
                <div className='formadoShadow'>

                    <div className='tituloPantalla'>
                        <p style={{ display: 'inline-block' }}> Datos Compañía {Gestor.IdCia + ' ' + Gestor.RazonSocial +' '+ Gestor.NombreComercial}</p>
                        <button className="botonCerrar" style={{ backgroundColor: '#f3f3f3', width: '50px' }} id="SalirHome" onClick={Salir} name="SalirHome"><i className="fa fa-times"></i></button>
                    </div>
                    <div className='row'>
                        <div className='col-25'>
                            <button onClick={Guardar}>Guardar</button>
                        </div>
                        <div className='col-75'>
                            <div className='row'>
                                <div className='col-25'>
                                    <button className={`tab-button ${ModoActual === 'D' ? 'active' : ''}`} onClick={() => setModoActual("D")}>Datos</button>
                                </div>
                                <div className='col-25'>
                                    <button className={`tab-button ${ModoActual === 'H' ? 'active' : ''}`} onClick={() => setModoActual("H")}>Hacienda</button>
                                </div>
                                <div className='col-25'>
                                    <button className={`tab-button ${ModoActual === 'C' ? 'active' : ''}`} onClick={() => setModoActual("C")}>Consecutivos</button>
                                </div>
                                <div className='col-25'>
                                    <button className={`tab-button ${ModoActual === 'U' ? 'active' : ''}`} onClick={() => setModoActual("U")}>Usuarios</button>
                                </div>
                            </div>
                        </div>

                    </div>
                    {ModoActual === 'D' ? <Datos
                        Gestor={Gestor}
                        CambiaDatosGestor={CambiaDatosGestor}
                        LosCantones={LosCantones}
                        InfoLicencia={InfoLicencia}
                        SubirLogo={SubirLogo}
                        CambiaInfoLicencia={CambiaInfoLicencia}
                        LosDistritos={LosDistritos}
                    /> : null}
                    {ModoActual === 'H' ? <Hacienda
                        Gestor={Gestor}
                        handleFileUpload={handleFileUpload}
                        CambiaDatosGestor={CambiaDatosGestor}
                        LasActividades={LasActividades}
                        EliminarActividad={EliminarActividad}
                        AgregarActividad={AgregarActividad}
                    /> : null}
                    {ModoActual === 'C' ? <ConsecutivosContenedor
                        LosConsecutivos={LosConsecutivos}
                        EliminarConsecutivo={EliminarConsecutivo}
                        ActualizarConsecutivo={ActualizarConsecutivo}
                        AgregarConsecutivo={AgregarConsecutivo}
                    /> : null}
                    {ModoActual === 'U' ? <Usuarios
                        Losusuarios={LosUsuarios}
                        AgregarUsuario={AgregarUsuario}
                        ActualizarUsuario={ActualizarUsuario}
                        ResetearClave={ResetearClave}
                        EliminarUsuario={EliminarUsuario}
                    /> : null}
                </div>
            </div>
        </div>
    }
    else {
        return <h2>Cargando...</h2>
    }

};
export default DetalleCia;